export const daliEsSystemConstants = {
    ES_SYSTEM_GROUP_LIST_REQUEST: "ES_SYSTEM_GROUP_LIST_REQUEST",
    ES_SYSTEM_GROUP_LIST_SUCCESS: "ES_SYSTEM_GROUP_LIST_SUCCESS",
    ES_SYSTEM_GROUP_LIST_FAILURE: "ES_SYSTEM_GROUP_LIST_FAILURE",
    ES_SYSTEM_CLEAR: "ES_SYSTEM_CLEAR",

    ES_SYSTEM_SCENE_LIST_REQUEST: "ES_SYSTEM_SCENE_LIST_REQUEST",
    ES_SYSTEM_SCENE_LIST_SUCCESS: "ES_SYSTEM_SCENE_LIST_SUCCESS",
    ES_SYSTEM_SCENE_LIST_FAILURE: "ES_SYSTEM_SCENE_LIST_FAILURE",

    ES_SYSTEM_GROUP_ITEM_REQUEST: "ES_SYSTEM_GROUP_ITEM_REQUEST",
    ES_SYSTEM_GROUP_ITEM_SUCCESS: "ES_SYSTEM_GROUP_ITEM_SUCCESS",
    ES_SYSTEM_GROUP_ITEM_FAILURE: "ES_SYSTEM_GROUP_ITEM_FAILURE",

    ES_SYSTEM_AREA_LIST_REQUEST: "ES_SYSTEM_AREA_LIST_REQUEST",
    ES_SYSTEM_AREA_LIST_SUCCESS: "ES_SYSTEM_AREA_LIST_SUCCESS",
    ES_SYSTEM_AREA_LIST_FAILURE: "ES_SYSTEM_AREA_LIST_FAILURE",

    ES_SYSTEM_AREA_ITEM_REQUEST: "ES_SYSTEM_AREA_ITEM_REQUEST",
    ES_SYSTEM_AREA_ITEM_SUCCESS: "ES_SYSTEM_AREA_ITEM_SUCCESS",
    ES_SYSTEM_AREA_ITEM_FAILURE: "ES_SYSTEM_AREA_ITEM_FAILURE",

    ES_SYSTEM_VALIDATION_FORM: "ES_SYSTEM_VALIDATION_FORM",

    ES_SYSTEM_GET_GROUPS_FROM_DEVICE_SUCCESS: "ES_SYSTEM_GET_GROUPS_FROM_DEVICE_SUCCESS",
    ES_SYSTEM_GET_GROUPS_FROM_DEVICE_FAILURE: "ES_SYSTEM_GET_GROUPS_FROM_DEVICE_FAILURE",
    ES_SYSTEM_GET_GROUPS_FROM_DEVICE_CLEAR: "ES_SYSTEM_GET_GROUPS_FROM_DEVICE_CLEAR"
};
